// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--2mvQU","default":"Button-module--default--HNN96 Button-module--button--2mvQU","main":"Button-module--main--GBrFD Button-module--button--2mvQU"};